import React from "react";
import { Table, Thead, Tbody, Tr, Th, Td } from "react-super-responsive-table";
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css";
import translate from "../../services/translation/lang";
import "react-tabs/style/react-tabs.css";
import { currencyFormatter } from "../../services/helpers/number-formatter";
import { isCurrencyHidden } from "../../services/helpers/login-params";
import moment from "moment";
import { useSelector } from "react-redux";

export default function GrpBetHistory() {
  const login = useSelector((s) => s.login);
  const betHistoryList = [
    {
      ticket_id: "111389",
      created_time: "2025-02-14T10:09:04Z",
      currency_code: login?.player_data?.currency_code,
      bet: 100.0,
      rows: 8,
      lvl: translate("low"),
      odd: 1.11,
      win: 111.0,
    },
    {
      ticket_id: "111388",
      created_time: "2025-02-14T10:09:00Z",
      currency_code: login?.player_data?.currency_code,
      bet: 100.0,
      rows: 8,
      lvl: translate("low"),
      odd: "0.00",
      win: 0.0,
    },
    {
      ticket_id: "111387",
      created_time: "2025-02-14T10:08:54Z",
      currency_code: login?.player_data?.currency_code,
      bet: 100.0,
      rows: 16,
      lvl: translate("high"),
      odd: 1.11,
      win: 111.0,
    },
    // {
    //   ticket_id: "111386",
    //   created_time: "2025-02-14T10:05:20Z",
    //   currency_code: "EUR",
    //   bet: 100.0,
    //   lanes: 25,
    //   cars: 1,
    //   odd: 1.11,
    //   win: 111.0,
    // },
    // {
    //   ticket_id: "111385",
    //   created_time: "2025-02-14T10:05:15Z",
    //   currency_code: "EUR",
    //   bet: 100.0,
    //   lanes: 25,
    //   cars: 1,
    //   odd: 1.06,
    //   win: 106.0,
    // },
  ];

  const formatDate = (dateString) => {
    const date = moment.utc(dateString).local();
    const formattedDate = date.format("YYYY-MM-DD"); // Formats as YYYY-MM-DD
    const formattedTime = date.format("HH:mm:ss"); // Formats as HH:MM:SS
    return { formattedDate, formattedTime };
  };

  return (
    <div className="hotkey-modal difficulity-modal bet-history-modal grp-bet-history">
      <div className="difficulty-info-title">{translate("bet_history")}</div>
          <div className="bet-history-table-holder">
            <Table>
              <Thead>
                <Tr>
                  <Th>{translate("ticket_id")}</Th>
                  <Th>{translate("created")}</Th>
                  {!isCurrencyHidden && <Th>{translate("currency")}</Th>}
                  <Th>{translate("bet")}</Th>
                  <Th>{translate("rows")}</Th>
                  <Th>{translate("lvl")}</Th>
                  <Th>{translate("multiplier")}</Th>
                  <Th>{translate("win")}</Th>
                </Tr>
              </Thead>
              <Tbody>
                {betHistoryList.map((ticket) => {
                      const { formattedDate, formattedTime } = formatDate(
                        ticket?.created_time
                      );
                      return (
                        <Tr key={ticket?.ticket_id}>
                          <Td>{ticket?.ticket_id}</Td>
                          <Td>
                            {formattedDate} <br className="hide-br" />
                            {formattedTime}
                          </Td>
                          {!isCurrencyHidden && <Td>{ticket?.currency_code}</Td>}
                          <Td>{currencyFormatter(ticket?.bet)}</Td>
                          <Td>{ticket?.rows}</Td>
                          <Td>{ticket?.lvl}</Td>
                          <Td>{ticket?.odd}x</Td>
                          <Td>{currencyFormatter(ticket?.win)}</Td>
                        </Tr>
                      );
                    })}
              </Tbody>
            </Table>
          </div>
    </div>
  );
}
